<template>
    <div class="sidebar">
        <div class="sidebar-wrapper">
            <ul class="nav flex text-white flex-col py-4 px-1">

              <router-link to="/dashboard" class="nav-item" active-class="active" data-testid="sidebar-link-1">
                <div class="nav-link">
                  <i class="fa-solid fa-table-cells-large nav-link-icon"/>
                  <p>{{$t('sidebar.dashboard')}}</p>
                </div>
              </router-link>

              <router-link to="/initial-monitoring" class="nav-item" active-class="active" data-testid="sidebar-link-2" v-if="hasMenuAction('INITIAL_MONITORING')">
                <div class="nav-link">
                  <i class="fa-solid fa-chart-column nav-link-icon"/>
                  <p>Дастлабки гаров мониторинги</p>
                </div>
              </router-link>

              <router-link to="/pledge-monitoring" class="nav-item" active-class="active" data-testid="sidebar-link-3" v-if="hasMenuAction('PLEDGE_MONITORING')">
                <div class="nav-link">
                  <i class="fa-solid fa-chart-column nav-link-icon"/>
                  <p>Жорий гаров мониторинги</p>
                </div>
              </router-link>

              <router-link to="/targeted-inspection-monitoring" class="nav-item" active-class="active" data-testid="sidebar-link-4" v-if="hasMenuAction('TARGETED_INSPECTION_MONITORING')">
                <div class="nav-link">
                  <i class="fa-solid fa-user-tie nav-link-icon w-8 h-8"/>
                  <p>Мақсадли инспексион мониторинг</p>
                </div>
              </router-link>

<!--              <router-link to="/current-inspection-monitoring" class="nav-item" active-class="active" data-testid="sidebar-link-5">
                <div class="nav-link">
                  <i class="fa-solid fa-user-tie nav-link-icon w-8 h-8"/>
                  <p>Жорий инспексион мониторинг</p>
                </div>
              </router-link>-->

            </ul>
        </div>

    </div>
</template>

<script>

import {mapActions} from "vuex";

export default {
  name: "Sidebar",
  data() {
    return {
    }
  },
  methods: {
    ...mapActions(["initMenus"])
  },
  mounted() {
    this.initMenus()
  }
}

</script>
